(() => {
  if (window.__trustpilotRatingBootstrapped) return
  window.__trustpilotRatingBootstrapped = true

  // The badge snippet starts this request inline so it runs while the page loads.
  const requests = window.__trustpilotRatingRequests || (window.__trustpilotRatingRequests = {})

  const fetchRating = (url) => {
    if (!requests[url]) {
      requests[url] = fetch(url)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null)
    }

    return requests[url].then((data) => {
      if (!data) return null

      // Trustpilot reports collected and imported product reviews separately.
      const summaries = [data.productReviewsSummary, data.importedProductReviewsSummary]
      let total = 0
      let weighted = 0
      summaries.forEach((summary) => {
        const count = summary?.numberOfReviews?.total || 0
        total += count
        weighted += count * (summary?.starsAverage || 0)
      })

      return total > 0 ? { rating: weighted / total, total } : null
    })
  }

  const init = (el) => {
    if (el.dataset.trustpilotRatingInit) return
    el.dataset.trustpilotRatingInit = 'true'

    const url = el.dataset.url
    if (!url) return

    fetchRating(url).then((result) => {
      if (!result || !el.isConnected) return

      const rating = result.rating.toFixed(1)
      el.querySelector('[data-trustpilot-rating-score]').textContent = rating
      el.querySelector('button')?.setAttribute('aria-label', `View reviews, rated ${rating}`)
      el.removeAttribute('hidden')
    })
  }

  const scan = () => document.querySelectorAll('[data-trustpilot-rating]').forEach(init)

  // The product page swaps its content when changing colour, so watch for new badges.
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan)
  } else {
    scan()
  }
})()
